// "use client";

// import React, { useState, useEffect } from "react";
// import Sidebar from "../../../Components/Sidebar";
// import TopNav from "../../../Components/TopNav";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import moment from "moment";
// import NoRecordFound from "../../../Components/NoRecordFound";

// // SERVICE IMPORT
// import { getPreBookQueryServ } from "../../../services/support.service";

// const PreBookQuery = () => {
//   const [list, setList] = useState([]);
//   const [showSkelton, setShowSkelton] = useState(false);

//   const [payload, setPayload] = useState({
//     searchKey: "",
//   });

//   // FILTERED LIST
//   const filteredList = list?.filter((item) => {
//     const search = payload?.searchKey?.toLowerCase();

//     return (
//       item?.fullName?.toLowerCase()?.includes(search) ||
//       item?.whatsappNumber?.toLowerCase()?.includes(search)
//     );
//   });

//   // GET PRE BOOK LIST
//   const handleGetPreBookList = async () => {
//     if (list.length === 0) {
//       setShowSkelton(true);
//     }

//     try {
//       const response = await getPreBookQueryServ();

//       console.log("pre book response", response);

//       setList(response?.data?.data || []);
//     } catch (error) {
//       console.log("error in pre book list", error);
//       toast.error("Failed to fetch pre-book queries");
//     }

//     setShowSkelton(false);
//   };

//   useEffect(() => {
//     handleGetPreBookList();
//   }, []);

//   // STATICS
//   const staticsArr = [
//     {
//       title: "Pre Booking Queries",
//       count: list?.length || 0,
//       bgColor: "#a60808",
//     },
//   ];

//   return (
//     <div className="bodyContainer">
//       <Sidebar
//         selectedMenu={"System Support"}
//         selectedItem={"Pre-Book Query"}
//       />

//       <div className="mainContainer">
//         <TopNav />

//         <div className="p-lg-4 p-md-3 p-2">
//           {/* TOP CARD */}
//           <div
//             className="row mx-0 p-0"
//             style={{
//               position: "relative",
//               top: "-75px",
//               marginBottom: "-75px",
//             }}
//           >
//             {staticsArr?.map((v, i) => {
//               return (
//                 <div className="col-md-4 col-12" key={i}>
//                   <div className="topCard shadow-sm py-4 px-3 rounded mb-3">
//                     <div className="d-flex align-items-center">
//                       <div
//                         className="p-2 shadow rounded"
//                         style={{ background: v?.bgColor }}
//                       >
//                         <img
//                           src="https://cdn-icons-png.flaticon.com/128/1827/1827392.png"
//                           alt="notify"
//                         />
//                       </div>

//                       <div className="ms-3">
//                         <h6>{v?.title}</h6>
//                         <h2 className="text-secondary">{v?.count}</h2>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           {/* HEADER */}
//           <div className="row m-0 p-0 d-flex align-items-center my-4 justify-content-between topActionForm">
//             <div className="col-lg-4 mb-2 col-md-12 col-12">
//               <h3 className="mb-0 text-bold text-secondary">
//                 Pre Booking Queries
//               </h3>
//             </div>

//             {/* SEARCH */}
//             <div className="col-lg-4 mb-2 col-md-6 col-12">
//               <input
//                 type="text"
//                 className="form-control borderRadius24"
//                 placeholder="Search by name / whatsapp number"
//                 value={payload?.searchKey}
//                 onChange={(e) =>
//                   setPayload({
//                     ...payload,
//                     searchKey: e.target.value,
//                   })
//                 }
//               />
//             </div>
//           </div>

//           {/* TABLE */}
//           <div className="mt-3">
//             <div className="card-body px-2">
//               <div className="table-responsive table-invoice">
//                 <table className="table">
//                   <tbody>
//                     {/* HEADER */}
//                     <tr
//                       style={{
//                         background: "#F3F3F3",
//                         color: "#000",
//                       }}
//                     >
//                       <th
//                         className="text-center py-3"
//                         style={{
//                           borderRadius: "30px 0px 0px 30px",
//                         }}
//                       >
//                         Sr. No
//                       </th>

//                       <th className="text-center py-3">
//                         Full Name
//                       </th>

//                       <th className="text-center py-3">
//                         Whatsapp Number
//                       </th>

//                       <th className="text-center py-3">
//                         Created At
//                       </th>
//                     </tr>

//                     <div className="py-2"></div>

//                     {/* SKELETON */}
//                     {showSkelton
//                       ? [1, 2, 3, 4, 5]?.map((v, i) => {
//                           return (
//                             <React.Fragment key={i}>
//                               <tr>
//                                 <td className="text-center">
//                                   <Skeleton width={40} height={25} />
//                                 </td>

//                                 <td className="text-center">
//                                   <Skeleton width={140} height={25} />
//                                 </td>

//                                 <td className="text-center">
//                                   <Skeleton width={160} height={25} />
//                                 </td>

//                                 <td className="text-center">
//                                   <Skeleton width={150} height={25} />
//                                 </td>
//                               </tr>

//                               <div className="py-2"></div>
//                             </React.Fragment>
//                           );
//                         })
//                       : filteredList?.map((v, i) => {
//                           return (
//                             <React.Fragment key={v?._id || i}>
//                               <tr>
//                                 {/* SERIAL */}
//                                 <td className="text-center">
//                                   {i + 1}
//                                 </td>

//                                 {/* NAME */}
//                                 <td className="font-weight-600 text-center">
//                                   {v?.fullName || "N/A"}
//                                 </td>

//                                 {/* NUMBER */}
//                                 <td className="font-weight-600 text-center">
//                                   {v?.whatsappNumber || "N/A"}
//                                 </td>

//                                 {/* DATE */}
//                                 <td className="font-weight-600 text-center">
//                                   {v?.createdAt
//                                     ? moment(v?.createdAt).format(
//                                         "DD MMM YYYY hh:mm A"
//                                       )
//                                     : "N/A"}
//                                 </td>
//                               </tr>

//                               <div className="py-2"></div>
//                             </React.Fragment>
//                           );
//                         })}
//                   </tbody>
//                 </table>

//                 {/* NO RECORD */}
//                 {filteredList?.length === 0 && !showSkelton && (
//                   <NoRecordFound />
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PreBookQuery;


"use client";

import React, { useState, useEffect } from "react";
import Sidebar from "../../../Components/Sidebar";
import TopNav from "../../../Components/TopNav";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import NoRecordFound from "../../../Components/NoRecordFound";

// SERVICE IMPORT
import { getPreBookQueryServ } from "../../../services/support.service";

/* ─── Scoped Styles ───────────────────────── */
const styles = `
  .pb-page {
    background: #f5f5f7;
    min-height: 100%;
    padding: 28px;
    font-family: 'Segoe UI', sans-serif;
  }

  /* stat card */
  .pb-stat-grid {
    display: grid;
    grid-template-columns: repeat(1, 320px);
    margin-bottom: 22px;
  }

  @media (max-width: 768px) {
    .pb-stat-grid {
      grid-template-columns: 1fr;
    }
  }

  .pb-stat-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #f0eded;
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .pb-stat-icon {
    width: 58px;
    height: 58px;
    border-radius: 16px;
    background: #fdf2f1;
    color: #a60808;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    flex-shrink: 0;
  }

  .pb-stat-title {
    font-size: 15px;
    color: #888;
    margin-bottom: 6px;
    font-weight: 500;
  }

  .pb-stat-count {
    font-size: 32px;
    font-weight: 700;
    color: #1c0a0a;
    line-height: 1;
  }

  /* toolbar */
  .pb-toolbar {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #f0eded;
    padding: 18px 22px;
    margin-bottom: 18px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
  }

  .pb-toolbar-title {
    font-size: 19px;
    font-weight: 700;
    color: #1c0a0a;
  }

  .pb-search-wrap {
    position: relative;
  }

  .pb-search-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #a60808;
    font-size: 16px;
  }

  .pb-search {
    width: 320px;
    height: 48px;
    border-radius: 12px;
    border: 1px solid #f0eded;
    background: #fafafa;
    padding: 0 16px 0 42px;
    font-size: 15px;
    color: #444;
    outline: none;
    transition: all 0.18s ease;
  }

  .pb-search:focus {
    border-color: #f0c0b8;
    background: #fff;
  }

  @media (max-width: 768px) {
    .pb-search {
      width: 100%;
    }

    .pb-search-wrap {
      width: 100%;
    }
  }

  /* table */
  .pb-table-wrap {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #f0eded;
    overflow: hidden;
  }

  .pb-table-scroll {
    overflow-x: auto;
  }

  .pb-table {
    width: 100%;
    border-collapse: collapse;
    min-width: 850px;
  }

  .pb-table thead tr {
    background: #fdf2f1;
  }

  .pb-table th {
    padding: 18px 20px;
    font-size: 14px;
    font-weight: 700;
    color: #a60808;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    white-space: nowrap;
    text-align: left;
  }

  .pb-table td {
    padding: 20px;
    border-top: 1px solid #f7f5f5;
    vertical-align: middle;
    font-size: 16px;
    color: #444;
  }

  .pb-table tbody tr:hover td {
    background: #fdfafa;
  }

  .pb-serial {
    color: #999;
    font-weight: 600;
    width: 80px;
  }

  .pb-user-cell {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .pb-avatar {
    width: 46px;
    height: 46px;
    border-radius: 50%;
    background: #fdf2f1;
    color: #a60808;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: 700;
    flex-shrink: 0;
  }

  .pb-user-name {
    font-size: 16px;
    font-weight: 600;
    color: #222;
  }

  .pb-phone {
    font-size: 16px;
    color: #666;
    font-family: monospace;
  }

  .pb-date {
    font-size: 15px;
    color: #777;
    white-space: nowrap;
  }

  .pb-empty {
    padding: 40px 20px;
  }
`;

const PreBookQuery = () => {
  const [list, setList] = useState([]);
  const [showSkelton, setShowSkelton] = useState(false);

  const [payload, setPayload] = useState({
    searchKey: "",
  });

  // FILTERED LIST
  const filteredList = list?.filter((item) => {
    const search = payload?.searchKey?.toLowerCase();

    return (
      item?.fullName?.toLowerCase()?.includes(search) ||
      item?.whatsappNumber?.toLowerCase()?.includes(search)
    );
  });

  // GET PRE BOOK LIST
  const handleGetPreBookList = async () => {
    if (list.length === 0) {
      setShowSkelton(true);
    }

    try {
      const response = await getPreBookQueryServ();

      console.log("pre book response", response);

      setList(response?.data?.data || []);
    } catch (error) {
      console.log("error in pre book list", error);
      toast.error("Failed to fetch pre-book queries");
    }

    setShowSkelton(false);
  };

  useEffect(() => {
    handleGetPreBookList();
  }, []);

  // INITIALS
  const getInitials = (name = "") => {
    return (
      name
        ?.split(" ")
        ?.map((n) => n[0])
        ?.join("")
        ?.toUpperCase()
        ?.slice(0, 2) || "U"
    );
  };

  // STATICS
  const staticsArr = [
    {
      title: "Pre Booking Queries",
      count: list?.length || 0,
    },
  ];

  return (
    <div className="bodyContainer">
      <style>{styles}</style>

      <Sidebar
        selectedMenu={"System Support"}
        selectedItem={"Pre-Book Query"}
      />

      <div className="mainContainer">

        <TopNav
          pageTitle="Pre Booking Queries"
          pagePath="Home / System Support / Pre-Book Query"
        />

        <div className="pb-page">

          {/* ── Stats ── */}
          <div className="pb-stat-grid">
            {staticsArr?.map((v, i) => (
              <div className="pb-stat-card" key={i}>

                <div className="pb-stat-icon">
                  <i className="ti ti-message-circle-question" />
                </div>

                <div>
                  <div className="pb-stat-title">
                    {v?.title}
                  </div>

                  <div className="pb-stat-count">
                    {v?.count}
                  </div>
                </div>

              </div>
            ))}
          </div>

          {/* ── Toolbar ── */}
          <div className="pb-toolbar">

            <div className="pb-toolbar-title">
              Pre Booking Queries
            </div>

            {/* SEARCH */}
            <div className="pb-search-wrap">

              <i className="ti ti-search pb-search-icon" />

              <input
                type="text"
                className="pb-search"
                placeholder="Search by name / whatsapp number"
                value={payload?.searchKey}
                onChange={(e) =>
                  setPayload({
                    ...payload,
                    searchKey: e.target.value,
                  })
                }
              />
            </div>

          </div>

          {/* ── Table ── */}
          <div className="pb-table-wrap">

            <div className="pb-table-scroll">

              <table className="pb-table">

                <thead>
                  <tr>
                    <th>#</th>
                    <th>Full Name</th>
                    <th>Whatsapp Number</th>
                    <th>Created At</th>
                  </tr>
                </thead>

                <tbody>

                  {/* Skeleton */}
                  {showSkelton ? (
                    [...Array(6)]?.map((_, i) => (
                      <tr key={i}>

                        {[1, 2, 3, 4].map((v) => (
                          <td key={v}>
                            <Skeleton height={24} />
                          </td>
                        ))}

                      </tr>
                    ))
                  ) : filteredList?.length > 0 ? (
                    filteredList?.map((v, i) => (
                      <tr key={v?._id || i}>

                        {/* SERIAL */}
                        <td className="pb-serial">
                          {i + 1}
                        </td>

                        {/* NAME */}
                        <td>
                          <div className="pb-user-cell">

                            <div className="pb-avatar">
                              {getInitials(v?.fullName)}
                            </div>

                            <div className="pb-user-name">
                              {v?.fullName || "N/A"}
                            </div>

                          </div>
                        </td>

                        {/* NUMBER */}
                        <td>
                          <span className="pb-phone">
                            {v?.whatsappNumber || "N/A"}
                          </span>
                        </td>

                        {/* DATE */}
                        <td>
                          <span className="pb-date">
                            {v?.createdAt
                              ? moment(v?.createdAt).format(
                                  "DD MMM YYYY hh:mm A"
                                )
                              : "N/A"}
                          </span>
                        </td>

                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="4"
                        className="pb-empty"
                      >
                        <NoRecordFound />
                      </td>
                    </tr>
                  )}

                </tbody>

              </table>

            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default PreBookQuery;